/* src/app/shared/components/tooltip/tooltip.component.scss */
:host {
  position: inherit;
}
.popover {
  display: block;
  background-color: white;
  position: relative;
}
/*# sourceMappingURL=tooltip.component.css.map */
